<div class="container py-4">
  <!-- Encabezado con Volver y Título -->
  <div class="d-flex align-items-center gap-2 mb-4">
    <button class="btn btn-outline-secondary" (click)="volverAtras()">
      <i class="fa-solid fa-arrow-left"></i>
    </button>
    <h3 class="text-primary mb-0">
      <i class="fa-solid fa-book me-2"></i>Libreta de {{ nombreCliente }}
    </h3>
    <button class="btn btn-success ms-auto" (click)="agregarDeuda(clienteId)">
      <i class="fa-solid fa-plus me-2"></i>Nueva Deuda
    </button>
  </div>

  <!-- Estados -->
  <div *ngIf="loading" class="text-center my-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <div *ngIf="!loading && deudas.length === 0" class="alert alert-info">
    El cliente no tiene deudas registradas.
  </div>

  <!-- Lista de deudas -->
  <div *ngIf="!loading && deudas.length">
    <div *ngFor="let deuda of deudas" class="card shadow-sm mb-4 border-0">
      <div class="card-header bg-light d-flex justify-content-between">
        <div>
          <i class="fa-solid fa-calendar-days me-2 text-primary"></i>
          {{ deuda.fecha | date:'short' }}
        </div>
        <span class="fw-bold text-danger">Subtotal: ${{ deuda.subTotalDeuda }}</span>
      </div>

      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-striped table-hover m-0">
            <thead class="table-light">
              <tr>
                <th>Producto</th>
                <th class="text-center">Cantidad</th>
                <th class="text-end">Precio Unitario</th>
                <th class="text-end">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let det of deuda.detalles">
                <td>{{ det.nombreProducto }}</td>
                <td class="text-center">{{ det.cantidad }}</td>
                <td class="text-end">
                  <ng-container *ngIf="modoPonerPrecios; else precioTexto">
                    <input
                      type="number"
                      class="form-control form-control-sm text-end"
                      [(ngModel)]="det.precioUnitario"
                      placeholder="$ Precio"
                      min="0"
                      step="0.01"
                      (ngModelChange)="recalcularSubtotal(det,deuda)"
                    />
                  </ng-container>
                  <ng-template #precioTexto>
                    {{ det.precioUnitario !== null ? ('$' + det.precioUnitario) : '--' }}
                  </ng-template>
                </td>
                <td class="text-end">
                  {{ det.subtotal !== null && det.subtotal !== undefined ? ('$' + det.subtotal) : '--' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Acciones y Total -->
  <div *ngIf="!loading && deudas.length" class="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-4">
    <!-- Botones de precios -->
    <div class="d-flex gap-2 flex-wrap">
      <button
        *ngIf="!modoPonerPrecios"
        class="btn btn-warning"
        (click)="activarModoPonerPrecios()">
        <i class="fa-solid fa-dollar-sign me-2"></i>Poner Precios
      </button>

      <button
        *ngIf="modoPonerPrecios"
        class="btn btn-success"
        (click)="guardarPrecios()">
        <i class="fa-solid fa-check me-2"></i>Guardar Precios
      </button>

      <button
        *ngIf="modoPonerPrecios"
        class="btn btn-outline-secondary"
        (click)="cancelarModoPrecios()">
        <i class="fa-solid fa-ban me-2"></i>Cancelar
      </button>
    </div>

    <!-- Botón Pagar y Total -->
    <div class="d-flex align-items-center gap-3 mt-2 mt-md-0">
      <button
        class="btn btn-outline-success"
        (click)="pagarDeuda()"
        [disabled]="hayProductosSinPrecio() || modoPonerPrecios">
        <i class="fa-solid fa-dollar-sign me-2"></i>Pagar Deuda
      </button>

      <h5 class="fw-bold text-success mb-0">
        Total Deuda: ${{ deudaTotal }}
      </h5>
    </div>
  </div>
</div>
